import { type ComponentPropsWithoutRef, type ReactNode, forwardRef } from "react";
import cx from "classnames";

import styles from "./Card.module.scss";

interface Props extends Omit<ComponentPropsWithoutRef<"div">, "children"> {
  children: ReactNode,
}

export const Card = forwardRef<HTMLDivElement, Props>(({
  children,
  className,
  ...props
}, ref) => {
  return (
    <div
      ref={ref}
      className={cx(styles.Card, className, {
        [styles.Clickable]: props.onClick,
      })}
      {...props}
    >
      {children}
    </div>
  )
})

Card.displayName = "Card";

